module.exports = __webpack_public_path__ + "static/takeda-face-1cf50a524ce51aba84379038f218af23.jpg";